import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Row, Col, DatePicker, InputNumber, message } from 'antd';
import dayjs from 'dayjs';
import {
  INVOICE_FIELDS,
  DEFAULT_SERVER_STATUS,
} from '../constants';

export default function InvoiceModal ({ visible, onCancel, onSave, initialData }) {
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [serverResponse, setServerResponse] = useState(DEFAULT_SERVER_STATUS);

  useEffect(() => {
    if (visible) {
      setServerResponse(DEFAULT_SERVER_STATUS);
      if (initialData) {
        form.setFieldsValue({
          ...initialData,
          invoice_date: dayjs(initialData.invoice_date),
        });
      } else {
        form.resetFields();
      }
    }
  }, [initialData, form, visible]);
  
  const onFinish = async values => {
    const response = await onSave({ ...initialData, ...values });
    const { success, code } = response;
    setServerResponse({success, code, message: response.message});
    if (success && !response.message) {
      form.resetFields();
      let toastMessage = 'Invoice created successfully';
      if (initialData && initialData.id) {
        toastMessage = 'Invoice updated successfully';
      }
      messageApi.success(toastMessage, 5);
    }
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'date':
        return <DatePicker style={{ width: '100%' }} placeholder="Enter invoice date" 
                        format='YYYY-MM-DD' />;
      case 'number':
        return <InputNumber style={{ width: '100%' }} step={1} />;
      default:
        return <Input />;
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={(initialData && initialData.id) ? 'Edit Invoice' : 'Add Invoice'}
      onOk={() => form.submit()}
    >
      {contextHolder}
      <Form
        form={form}
        name="invoice"
        layout="vertical"
        onFinish={onFinish}
        >
        <Row gutter={16}>
            {INVOICE_FIELDS.map(field => (
            <Col
                key={field.name}
                xs={24}
                sm={24}
                md={12}
            >
              <Form.Item
              key={field.name}
              name={field.name}
              label={field.label}
              rules={field.rules}
              >
                {renderField(field)}
              </Form.Item>
            </Col>
            ))}
        </Row>
      </Form>
      {
        (!serverResponse.status && serverResponse.message) &&
        <div style={{textAlign: 'center'}}>
          <label style={{color: 'red'}}>{serverResponse.message} {serverResponse.code ? `(${serverResponse.code})` : ''}</label>
        </div>
      }
    </Modal>
  );
}
